import { useEffect, useState } from 'react';
import { isPendingPix, isPixExpired, resolvePixExpiration, type Transaction } from '@src/domains/transactions';

type Input = {
  transaction: Transaction | null | undefined;
  pollingIntervalMs: number;
  onSync: () => void;
};

export const usePixPayment = ({ transaction, pollingIntervalMs, onSync }: Input) => {
  const now = new Date();
  const isPending = isPendingPix(transaction);
  const expiration = resolvePixExpiration(transaction);
  const isExpired = isPixExpired(expiration, now);

  const [syncInstant, setSyncInstant] = useState(() => now.getTime());

  useEffect(() => {
    if (isPending) {
      onSync();

      if (!isExpired) {
        const id = setTimeout(() => setSyncInstant(new Date().getTime()), pollingIntervalMs);
        return () => clearTimeout(id);
      }
    }

    return () => 1;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPending, syncInstant]);

  return { isPending, isExpired };
};
